import React from "react";
import ParticlesBg from "particles-bg";

import Menu from "../components/Menu";
import Footer from "../components/Footer";

function Landing() {
  document.title = "Gamepigeon Solvers"

  return (
    <div >
        <ParticlesBg type="circle" bg={true}/>

        <Menu colorScheme={'dark'}/>

        <div className="fixed-top text-light d-flex flex-column align-items-center justify-content-center" style={{height: '100vh', zIndex: 0}}>
            <h1 class="display-3">Gamepigeon Solvers</h1>
            <h5>by <a href="https://skyao2002.github.io/" className="text-light">Steven Yao</a></h5>
        </div>

        <Footer textColor="white" />

      </div>
  );
}

export default Landing;
